<template>
  <div>
    <pc-header></pc-header>
    <div class="header-wrap">
      <img src="../../../assets/images/news/news-head-bg.png" />
    </div>
    <div class="content-wrap">
      <div class="title" style="text-align: center;">
        关于降低商户银行卡刷卡手续费的公告
      </div>
      <div class="time" style="text-align: center;">
        发布时间：&nbsp;&nbsp;&nbsp;&nbsp;2021-08-10
      </div>
      <div class="news_details_container">
        <p>尊敬的商户：</p>
        <p style="text-indent: 2em;">为贯彻落实国务院关于降低小微企业和个体工商户支付手续费工作部署和《中国人民银行 银保监会 发展改革委 市场监管总局关于降低小微企业和个体工商户支付手续费的通知》（银发〔2021〕169号），中国支付清算协会和中国银行业协会共同发布《关于降低小微企业和个体工商户支付手续费的倡议书》。我公司积极主动承担社会责任，进一步降低商户的经营成本，结合业务实际开展情况以及中国银联股份有限公司发布的《关于调整小微企业和个体工商户有关银联卡业务手续费的函》（银联函〔2021〕32号），计划自2021年9月30日起三年内，施行降低银行卡刷卡手续费的优惠政策。同时我公司将做好以下服务工作：</p>
        <ol class="custom_num list-paddingleft-1"><li class="list-num-1-1 list-num-paddingleft-1"><p>1、做好宣传和信息披露，确保商户对优惠政策充分知晓；</p></li><li class="list-num-1-2 list-num-paddingleft-1"><p>2、做好各项准备工作，制定业务规则、技术实施方案和应急处置方案，确保9月30日前具备业务和系统支撑能力，将降费措施落实到位；</p></li><li class="list-num-1-3 list-num-paddingleft-1"><p>3、切实做好金融消费者权益保护工作，畅通投诉和争议处理的渠道，确保快速响应、及时处理。&nbsp;</p></li></ol>
        <p style="text-align: left; text-indent: 2em;">今后，海科融通作为支付机构的国家队成员，将继续坚守和践行“支付为民”的理念，积极履行社会责任，多措并举，切实推动银行卡刷卡手续费减免措施的落地，与广大商户一道共克时艰。</p>
        <p style="text-align: right;">北京海科融通支付服务有限公司</p>
        <p style="text-align: right;">2021年8月9日</p>
      </div>
    </div>

    <pc-footer></pc-footer>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  data() {
    return {
      pageIndex: 0,
      isFirstPage: false,
      isSecondPage: false,
      isThirdPage: false,
    }
  },
  mounted() {
    this.pageIndex = this.$route.query.activeIndex
    if (this.pageIndex == 1) {
      this.isSecondPage = true
    } else if (this.pageIndex == 2) {
      this.isThirdPage = true
    } else {
      this.isFirstPage = true
    }
  },
}
</script>

<style lang="less" scoped>
.header-wrap {
  // margin-top: -60px;
}
img {
  width: 100%;
  object-fit: cover;
}

.content-wrap {
  padding-top: 50px;
  padding-bottom: 50px;
  width: 900px;
  margin: 0 auto;
  color: #000;

  .title {
    font-size: 32px;
    font-weight: bold;
    line-height: 38px;
    color: #000000;
    opacity: 0.85;
  }
  .time {
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    color: #a8a8a8;
    margin-top: 15px;
  }
  .news_details_container p {
    font-size: 16px;
    line-height: 30px;
    padding: 20px 0;
  }
}
</style>